"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectSaraiva = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _utils = require("../utils");
var _Menu = _interopRequireDefault(require("../menu/Menu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types, import/no-named-as-default, react/jsx-no-duplicate-props */

const useStyles = (0, _core.makeStyles)(theme => ({
  input: {
    width: '100%',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'white !important'
    },
    '& .MuiOutlinedInput-input': {
      padding: '18px 32px 18px 14px'
    }
  },
  select: {
    padding: '18px, 14px'
  },
  textError: {
    color: theme.palette.error.main
  },
  label: {
    '&.Mui-focused': {
      color: theme.palette.error.main
    }
  },
  cascadeInput: {
    cursor: 'pointer'
  },
  cascadeInputLabel: {
    zIndex: 0,
    '&.MuiInputLabel-shrink': {
      zIndex: 1
    }
  }
}));
const SelectSaraiva = _ref => {
  let {
    disabled,
    error,
    label,
    helperText,
    iconComponent,
    children,
    onChange,
    value,
    size,
    className,
    cascade,
    selectedLabel
  } = _ref;
  const cascadeInputRef = (0, _react.useRef)();
  const cascadeRef = (0, _react.useRef)();
  const [anchorEl, setAnchorEl] = (0, _react.useState)();
  const classes = useStyles();
  function onClickCascadeInput(e) {
    cascadeInputRef.current.focus();
    setAnchorEl(e.currentTarget);
  }
  if (cascade) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      label: value ? selectedLabel : label,
      variant: "outlined",
      helperText: helperText,
      value: value,
      onClick: onClickCascadeInput,
      className: className,
      ref: cascadeRef,
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_icons.ArrowDropDown, null),
        readOnly: true,
        className: classes.cascadeInput
      },
      inputProps: {
        ref: cascadeInputRef,
        className: classes.cascadeInput
      },
      InputLabelProps: {
        className: classes.cascadeInputLabel
      }
    }), /*#__PURE__*/_react.default.createElement(_Menu.default, {
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: () => setAnchorEl(),
      onClick: () => setAnchorEl(),
      style: {
        minWidth: cascadeRef?.current?.getBoundingClientRect?.()?.width,
        marginTop: -cascadeRef?.current?.getBoundingClientRect?.()?.height
      },
      popperOptions: {
        modifiers: {
          flip: {
            enabled: false
          }
        }
      },
      paperProps: {
        style: {
          maxHeight: window.innerHeight - cascadeRef?.current?.getBoundingClientRect?.()?.top - 10,
          overflow: 'auto'
        }
      }
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "outlined",
    fullWidth: size === 'full'
  }, /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    className: error && classes.label
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, {
    value: value,
    onChange: onChange,
    label: label,
    disabled: disabled,
    error: error,
    IconComponent: iconComponent,
    className: classes.input,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    }
  }, children), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    className: error ? classes.textError : ''
  }, helperText));
};
exports.SelectSaraiva = SelectSaraiva;
SelectSaraiva.propTypes = {
  /**
   * Seleciona o tamanho do input
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),
  /**
   * Se true, o input fica desabilitado (cinza e sem poder ser acessado)
   */
  disabled: _propTypes.default.bool,
  /**
   * Se true, o contorno do Input fica vermelho
   */
  error: _propTypes.default.bool,
  /**
   * icone que irá substituir a seta lateral, caso necessário
   */
  // eslint-disable-next-line react/require-default-props
  iconComponent: _propTypes.default.element,
  /**
   * Label que fica como placeholder no input e que fica sobre o input ao ser selecionado
   */
  label: _propTypes.default.string,
  /**
   * Texto de auxilio que fica abaixo do input de select
   */
  helperText: _propTypes.default.string,
  /**
   * Objeto para adicionar as opções do select, sejam MenuItems, Calendário ou outros
   */
  children: _propTypes.default.node,
  /**
   * Função para determinar qual estado está selecionado
   */
  onChange: _propTypes.default.func,
  /**
   * Valor do input
   */
  value: _propTypes.default.string,
  /**
   * Ativa um tipo diferente de Select que suporta itens cascatas
   */
  cascade: _propTypes.default.bool,
  /**
   * Para Select Cascata é possível escolher o que aparecer de label quando existe um item selecionado
   */
  selectedLabel: _propTypes.default.string,
  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string
};
SelectSaraiva.defaultProps = {
  disabled: false,
  error: false,
  label: 'Teste',
  helperText: '',
  onChange: null,
  value: '',
  children: '',
  size: 'sm',
  cascade: false,
  selectedLabel: null,
  className: null
};
var _default = exports.default = SelectSaraiva;